import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">        
        <path d="M27.691 22.223a5.903 5.903 0 0 0-1.351-1.752l-.006-.005a7.933 7.933 0 0 0-2.112-1.216l-.054-.018a18.07 18.07 0 0 0-2.181-.783l-.14-.035c-.633-.172-1.506-.396-2.632-.678q-1.318-.313-2.164-.564a15.895 15.895 0 0 1-1.92-.714l.104.042a5.34 5.34 0 0 1-1.425-.845l.009.007a3.85 3.85 0 0 1-.821-1.079l-.01-.022a2.965 2.965 0 0 1-.327-1.363l.001-.063v.003a3.217 3.217 0 0 1 1.427-2.781l.012-.007a7.685 7.685 0 0 1 4.535-1.115l-.023-.001a8.676 8.676 0 0 1 4.88 1.219l-.04-.022a3.628 3.628 0 0 1 1.655 3.36l.001-.013c.001.442.359.8.801.8h.928c.442 0 .8-.358.801-.8v-.224a5.888 5.888 0 0 0-2.613-5.107l-.021-.013a10.923 10.923 0 0 0-6.413-1.727l.022-.001a10.156 10.156 0 0 0-6.175 1.684l.038-.024a5.627 5.627 0 0 0-2.375 4.781v-.009.068c0 .906.215 1.762.598 2.519l-.015-.032a6.12 6.12 0 0 0 1.362 1.814l.005.004a7.762 7.762 0 0 0 2.032 1.238l.052.019c.575.266 1.291.538 2.027.766l.133.035c.597.175 1.363.37 2.285.584.932.233 1.617.408 2.051.524q.64.173 1.726.518a6.345 6.345 0 0 1 1.485.629l-.03-.016c.399.264.746.532 1.072.822l-.009-.008c.279.231.498.526.635.862l.005.015c.129.348.204.749.204 1.168v.055-.003l.001.098a3.296 3.296 0 0 1-1.554 2.8l-.014.008a8.595 8.595 0 0 1-4.889 1.157l.024.001a9.457 9.457 0 0 1-5.025-1.188l.048.025a4.028 4.028 0 0 1-2.003-3.137l-.001-.015a.801.801 0 0 0-.989-.684l.005-.001-.928.225a.8.8 0 0 0-.604.883v-.004a6.443 6.443 0 0 0 3.006 4.765l.027.016a11.635 11.635 0 0 0 6.455 1.613l-.023.001a11.12 11.12 0 0 0 6.554-1.708l-.046.027a5.679 5.679 0 0 0 2.515-4.887v.008-.07c0-.887-.218-1.722-.602-2.457l.014.029z" fill="currentColor"
    transform="translate(19, 26)"/>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
